import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Controller, useWatch } from "react-hook-form";
import FormControl from "@mui/material/FormControl";
import SelectMUI from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";

function Select({
  methods,
  label,
  name,
  required,
  items,
  defaultValue,
  variant,
  dependOfLoader,
  dependOf,
  onChange,
}) {
  const {
    control,
    formState: { errors },
    setValue,
  } = methods;
  const [itemsToDisplay, setItems] = useState(items);

  const dependOfValue = useWatch({
    control,
    name: dependOf,
  });

  useEffect(() => {
    if (dependOfLoader) {
      dependOfLoader(dependOf, dependOfValue, setItems);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependOf, dependOfValue]);

  return (
    <React.Fragment>
      <Controller
        name={name}
        control={control}
        rules={{ required }}
        defaultValue={defaultValue}
        render={({ field, fieldState }) => (
          <FormControl
            fullWidth
            required={!!required}
            error={errors?.hasOwnProperty(name)}
          >
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <SelectMUI
              {...field}
              value={field.value}
              labelId={`${name}-label`}
              id={`${name}-id`}
              label={label}
              variant={variant}
              onChange={(event) => {
                setValue(name, event.target.value);
                onChange(
                  event,
                  itemsToDisplay.find(
                    (item) => item.value === event.target.value
                  )
                );
              }}
            >
              {itemsToDisplay.map((option, i) => (
                <MenuItem value={option.value} key={i}>
                  {option.label}
                </MenuItem>
              ))}
            </SelectMUI>
            <FormHelperText>
              {errors?.hasOwnProperty(name) && errors[name].message
                ? errors[name].message
                : " "}
            </FormHelperText>
          </FormControl>
        )}
      />
    </React.Fragment>
  );
}

Select.defaultProps = {
  label: "Sélection",
  name: "select",
  required: "Merci d'effectuer une sélection",
  items: [],
  defaultValue: "",
  variant: "outlined",
  dependOfLoader: null,
  dependOf: null,
  onChange: () => {},
};

Select.propTypes = {
  /**
   * methods du useForm()
   */
  methods: PropTypes.instanceOf(Object),
  /**
   * Label du select
   */
  label: PropTypes.string,
  /**
   * Name du tag HTML input
   */
  name: PropTypes.string,
  /**
   * Message d'erreur si le champ est requis
   */
  required: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  /**
   * Collection des options à afficher
   */
  items: PropTypes.arrayOf(PropTypes.object),
  /**
   * Valeur par défaut sélectionnée dans le select
   */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The variant to use
   * 'filled'
   * | 'outlined'
   * | 'standard'
   */
  variant: PropTypes.string,
  /**
   * Fonction à appeler pour charger les données en asynchrone
   * dataLoader: (dependOf, dependOfValue, setItems) => {}
   */
  dependOfLoader: PropTypes.func,
  /**
   * Nom du champ de dépendance dans le formulaire
   */
  dependOf: PropTypes.string,
  /**
   * Fonction à appeler lors du changement de valeur
   * onChange: (event, newValue) => {}
   */
  onChange: PropTypes.func,
};

export default Select;
